// This app's theme uses palette.primary/secondary.main = #000000 (dark base
// colors), not accents. The real accent is the blue the sidebar hardcodes for
// active items. Centralise it here so the Log Analyzer stays consistent with the
// rest of the app rather than rendering black-on-black.
export const ACCENT = "#3a8eff";
